interface RadioFieldProps {
  options: {
    label: React.ReactNode;
    value: string;
  }[];
  containerClass?: string;
  name: string;
  onChange: (option: any) => void;
  defaultValue?: any;
  value?: string;
}

const RadioField: React.FC<RadioFieldProps> = ({
  containerClass = "flex-col gap-4 cursor-pointer",
  options,
  name,
  onChange,
  defaultValue,
  value,
}) => {
  return (
    <div className={containerClass}>
      {options &&
        options?.map((option) => (
          <div key={option?.value || defaultValue}>
            <label className="relative flex items-center p-3 rounded-full cursor-pointer gap-2">
              <input
                checked={option?.value === value}
                type="radio"
                className="cursor-pointer accent-primary"
                value={option?.value || defaultValue}
                name={name}
                onChange={() => onChange(option)}
              />
              {option?.label}
            </label>
          </div>
        ))}
    </div>
  );
};

export default RadioField;
